// @flow strict

import {createContext, useContext, type Context} from 'react';
import type {ConversationBuilderState, ConversationDispatch} from './reducer';


type ChatbotContext = {
  state: ConversationBuilderState,
  dispatch: ConversationDispatch,
  ...
};

export const ChatbotStateContext: Context<ChatbotContext> = createContext({});

export function useChatbotStateContext(): ChatbotContext {
  const chatbotContext = useContext(ChatbotStateContext);
  if (!chatbotContext) {
    throw new Error(
      'useChatbotStateContext hook is not used inside a chatbot state tree',
    );
  }
  return chatbotContext;
}
